import React, { useState } from "react"
import styled, {keyframes, createGlobalStyle} from "styled-components"
import { ThemeToggler } from "gatsby-plugin-dark-mode"
import { FaMoon } from "react-icons/fa"
import { FiSun, FiExternalLink } from "react-icons/fi"
import { Link } from "gatsby"
import { CgWorkAlt } from "react-icons/cg"
import {
  AiOutlineBook,
  AiOutlineMail,
  AiFillGithub,
  AiFillLinkedin,
  AiOutlineInstagram,
  AiOutlineHome,
} from "react-icons/ai"

const bgAnimation = keyframes`
  0%{
      background-color: transparent;
  }

  100%{
      background-color: var(--color-sidebar-2);
      color: var(--sidebar-hover);
  }
`

const marginRight = keyframes`
    0%{
      margin-right: .5rem;
  }

  100%{
    margin-right: 1rem;
  }
`




const Layout = ({ children }) => {
  const [open, setOpen] = useState(false)

  const GlobalStyle = createGlobalStyle`
  body {
    overflow-y: ${props => (props.overflow ? 'hidden' : 'auto')};
  }
`

  return (
    <LayoutStyled>
      <GlobalStyle overflow={open}/>
      <Sidebar className={`${open ? "open-sidebar" : "closed-sidebar"}`}>
        <HamburgerComponent className="wrapper" onClick={() => setOpen(!open)}>
          <div
            className={`wrapper circle ${
              open ? "wrapper close" : "wrapper icon"
            }`}
          >
            <span className="line top"></span>
            <span className="line middle"></span>
            <span className="line bottom"></span>
          </div>
        </HamburgerComponent>
          <ThemeToggler>
          {({ theme, toggleTheme }) => (
            <Switch className="switch">
              <FaMoon className="icon moon" />
              <input
                className="checkbox"
                type="checkbox"
                onChange={e => toggleTheme(e.target.checked ? "dark" : "light")}
                checked={theme === "dark"}
              />{" "}
              <span class="slider round"></span>
              <FiSun className="icon sun" />
            </Switch>
          )}
        </ThemeToggler>
        

        <ul>
          <Img className="img">
            <h1>Luidy</h1>
          </Img>
          <Link className="link" activeClassName="active" to="/">
            <AiOutlineHome className="icon" />
            <span>Home</span>
          </Link>
          <Link className="link" activeClassName="active" to="/portfolio/">
            <CgWorkAlt className="icon" />
            <span>Portfolio</span>
          </Link>
          <Link
            className="link"
            activeClassName="active"
            partiallyActive={true}
          >
            <AiOutlineBook className="icon" />
            <span>Blog</span>
          </Link>
          <a className="link" activeClassName="active" href="mailto:luidy.dias@outlook.com">
            <AiOutlineMail className="icon" />
            <span>Contact-me</span>
            <FiExternalLink className="link_icon"/>
          </a>
        </ul>
        <SocialMedia className="social">
          <div>
            <a href="https://github.com/luuidy" target="_blank">
              <AiFillGithub className="icon" />
            </a>
            <a href="https://www.linkedin.com/luidydias/" target="_blank">
              <AiFillLinkedin className="icon" />
            </a>
            <a href="https://www.instagram.com/luidydias_/" target="_blank">
              <AiOutlineInstagram className="icon" />
            </a>
          </div>
          <span>
            © 2020 • Designed & Developed by <strong>Luidy Dias</strong>
          </span>
        </SocialMedia>
      </Sidebar>
      <Children>{children}</Children>
    </LayoutStyled>
  )
}

const Switch = styled.label`
  position: relative;
  margin-left: auto;
  margin-right: 2rem;
  display: flex;
  align-items: center;
  width: 70px;
  height: 30px;
  min-width: 70px;
  min-height: 30px;

  input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  /* The slider */
  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: var(--color-sidebar-2);
    -webkit-transition: 0.4s;
    transition: 0.4s;
  }

  .slider:before {
    position: absolute;
    content: "";
    height: 23px;
    width: 23px;
    left: 4px;
    bottom: 4px;
    background-color: white;
    z-index: 10;
    -webkit-transition: 0.4s;
    transition: 0.4s;
  }

  input:checked + .slider {
    background-color: #333333;
  }

  input:focus + .slider {
    
  }

  input:checked + .slider:before {
    -webkit-transform: translateX(26px);
    -ms-transform: translateX(26px);
    transform: translateX(36px);
  }

  .slider.round {
    border-radius: 40px;
  }

  .slider.round:before {
    border-radius: 50%;
  }

  .icon {
    cursor: pointer;
  }

  .sun {
    position: absolute;
    left: 14%;
    color: var(--color-text-1) !important;
  }

  .moon {
    z-index: 5;
    color: var(--color-text-1) !important;
    position: absolute;
    right: 15%;
  }

  @media (max-width: 1200px) {
    display: none;
  }
`

const LayoutStyled = styled.div`
  width: 100%;
  height: 100%;
  display: relative;

  .open-sidebar {
    all: unset;
    width: 100%;
    min-width: 220px;
    position: fixed;
    bottom: 0;
    top: 0;
    left: 0;
    z-index: 50;
    display: flex;
    padding: 2rem 0;
    padding-top: 4rem;
    flex-direction: column;
    background-color: var(--sidebar-bg);
    box-shadow: 0px 0px 30px var(--sidebar-shadow);
    overflow-y: hidden !important;
    transition: all 0.4s;
    
    .img {
      display: block;
      font-family: "Oswald", sans-serif !important;
    }

    .wrapper {
      position: absolute;
      top: 3%;
      right: 5%;
    }

    .switch {
      display: flex;
      margin-top: 2rem;
    }

    ul {
      // padding: 0 1rem;
      .icon {
        display: none !important;
      }

      span {
        display: block !important;
      }
      .link {
        padding: 1.2rem 1rem;
        font-size: 16px;
        text-transform: uppercase;
        color: var(--color-sidebar-1);
        font-weight: 400;
        letter-spacing: 1px;
        font-family: "Oswald", sans-serif !important;
        border-left: 5px solid transparent;
        background-color: transparent;
        display: flex;
        align-items: center;
        cursor: pointer;
        transition: all 0.4s;

        .icon {
          display: none;
        }

        &:hover {
          color: var(--sidebar-hover);
        }
      }

          // BLOG
    .link:nth-of-type(3){
        justify-content: space-between;
        
        &:hover{
          color: var(--color-sidebar-1);
        }
  
        &::after{
            content: "Coming Soon";
            border-radius: 2px;
            padding: .2rem .4rem;
            font-family: 'Source Sans Pro', sans-serif !important;
            text-transform: none;
            font-size: 14px;
            font-weight: 300px;
            letter-spacing: 0px;
            background-color: var(--color-primary);
            color: white;
        }
          
        @media (max-width: 1200px) {
          &::after{
            display: block !important;
          }

          &:hover{
                    color: var(--sidebar-hover);
          }
        }
    }

      .active {
        &::before {
          content: "";
          display: block;
          margin-right: 1rem;
          width: 4px;
          height: 10px;
          background-color: var(--color-primary);
          transition: all 0.4s ease-out;
        }
        background-color: var(--color-sidebar-2);
        color: var(--sidebar-hover);
        margin-left: 0rem !important;
        .icon {
          color: var(--sidebar-hover);
        }
      }
    }

    .social {
      span {
        display: block;
      }

      div {
        flex-direction: row !important;

        .icon {
          margin: 0;
          font-size: 20px;
          margin: 0 0.2rem;
        }
      }
    }
    @media (min-width: 1201px) {
      width: 18%;
      .switch {
        display: flex;
        margin-top: 0rem;
      }
    }

    @media (max-width: 500px) {
      .img{
        margin-bottom: 1rem;
      }
      ul{
        .link{
          font-size: 14px;
          padding: .8rem .6rem;
        }
      }
    }
  }
`

const Img = styled.div`
  padding: 0 3rem;
  margin-bottom: 2rem;
  margin-top: 1rem;

  h1 {
    color: var(--color-text-1) !important;
    font-weight: 400;
    display: inline-block;
    font-size: 32px;

    &::after {
      content: "";
      display: inline-block;
      margin-right: 1rem;
      width: 5px;
      height: 5px;
      margin-left: auto;
      background-color: var(--color-primary);
      transition: all 0.4s ease-out;
    }
  }

`
/////////////////////////////////////// SIDEBAR
const Sidebar = styled.aside`
  all: unset;
  width: 18%;
  min-width: 220px;
  position: fixed;
  bottom: 0;
  top: 0;
  left: 0;
  z-index: 50;
  background-color: var(--sidebar-bg);
  box-shadow: 0px 0px 30px var(--sidebar-shadow);
  display: flex;
  padding: 2rem 0;
  padding-top: 3rem;
  flex-direction: column;
  transition: all 0.4s;

  ul {
    // padding: 0 1rem;
    .link {
      padding: 1.2rem 1rem;
      font-size: 16px;
      text-transform: uppercase;
      color: var(--color-sidebar-1);
      font-weight: 400;
      letter-spacing: 1px;
      font-family: "Oswald", sans-serif !important;
      border-left: 5px solid transparent;
      background-color: transparent;
      display: flex;
      align-items: center;
      cursor: pointer;
      transition: all 0.4s;

      .icon {
        display: none;
      }

      &:hover {
        color: var(--sidebar-hover);
      }
    }

    // CONTACT
    .link:nth-last-of-type(1){
        display: block;
        .link_icon{
          margin-left: .2rem;
          font-size: 16px;
          color: var(--color-primary);
        }

        @media (max-width: 1200px) {
            .link_icon{
              display: none;
            }
        }
    }

    // BLOG
    .link:nth-of-type(3){
        justify-content: space-between;
        
        &:hover{
          color: var(--color-sidebar-1);
        }
  
        &::after{
            content: "Coming Soon";
            border-radius: 2px;
            padding: .2rem .4rem;
            font-family: 'Source Sans Pro', sans-serif !important;
            text-transform: none;
            font-size: 14px;
            font-weight: 300px;
            letter-spacing: 0px;
            background-color: var(--color-primary);
            color: white;
        }
          
        @media (max-width: 1200px) {
          &::after{
            display: none !important;
          }

          &:hover{
                    color: var(--sidebar-hover);
          }
        }
    }

    .active {
      &::before {
        content: "";
        display: block;
        width: 4px;
        height: 10px;
        background-color: var(--color-primary);
        animation: ${marginRight} .4s forwards;
      }
      animation: ${bgAnimation} .8s forwards;
      margin-left: 0rem !important;
      .icon {
        color: var(--sidebar-hover);
      }
    }
  }

  //////////// RESPONSIVIDADE / CLOSED
  @media (max-width: 1200px) {
    width: 10%;
    min-width: 60px;
    position: fixed;
    bottom: 0;
    top: 0;
    left: 0;
    z-index: 50;
    background-color: var(--sidebar-bg);
    box-shadow: 0px 0px 30px var(--sidebar-shadow);
    display: flex;
    padding-top: .5rem;
    padding-bottom: 1rem;
    flex-direction: column;
    justify-content: space-between;
    transition: all 0.4s;

    .img {
      display: none;
    }

    ul {
      margin-bottom: auto;
      margin-top: 1rem !important;
      span {
        display: none !important;
      }

      // padding: 0 1rem;
      .icon {
        margin: 0 auto;
        font-size: 30px;
        color: var(--color-sidebar-1);
        display: block !important;
        transition: all 0.4s;

        &:hover {
          color: var(--sidebar-hover);
        }

      }
      all: initial;
      .link {
        all: initial;
        padding: 1.2rem 1rem;
        text-transform: uppercase;
        color: var(--color-sidebar-1);
        font-weight: 400;
        letter-spacing: 1px;
        border-bottom: 1px solid var(--sidebar-border);
        background-color: transparent;
        display: flex;
        align-items: center;
        cursor: pointer;
        transition: all 0.4s;

        &:hover {
          margin: 0;
        }

        &::before {
          content: "";
          display: none;
        }
      }
      .active {
        background-color: var(--color-sidebar-2);
        color: var(--color-primary);
      }
    }
  }

  @media (max-width: 500px) {
    ul{
      margin-top: .5rem;
    .icon {
        font-size: 20px !important;
      }
    }
  }
`

const Children = styled.div`
  width: 82%;
  float: right;
  height: 100%;

  @media (max-width: 1200px) {
    width: 90%;
  }
`

const HamburgerComponent = styled.div`
  display: none;
  margin: 0 auto;
  position: relative;
  padding: 12px;
  cursor: pointer;
  transition: all 0.4s;

  .circle {
    width: 30px;
    height: 30px;
    position: relative;
  }

  .line {
    position: absolute;
    height: 3px;
    width: 100%;
    background-color: var(--color-grey-2);
    border-radius: 8px;
    transition: all cubic-bezier(0.26, 0.1, 0.27, 1.55) 0.35s;
  }

  .close .top {
    transform: rotate(45deg);
    top: 48%;
    background-color: var(--color-grey-2);
  }

  .close .middle,
  .close .bottom {
    transform: rotate(-45deg);
    top: 48%;
    background-color: var(--color-grey-2);
  }

  .top {
    top: 18%;
  }

  .middle {
    top: 48%;
  }

  .bottom {
    top: 78%;
  }

  &:hover {
    .line {
      background-color: var(--sidebar-hover);
    }
  }

  @media (max-width: 1200px) {
    display: block;
  }
`

const SocialMedia = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  padding: 0 0.5rem;
  margin-top: auto;

  div {
    display: flex;
    justify-content: center;
  }
  .icon {
    color: var(--color-text-1);
    font-size: 20px;
    margin: 0 0.2rem;
  }

  span {
    font-size: 14px;
    margin-top: 1rem;
    font-weight: 400;
    color: var(--color-sidebar-3);
    font-family: "Source Sans Pro", sans-serif !important;

    strong {
      color: var(--color-text-1);
      font-weight: 400;
    }
  }

  @media (max-width: 1200px) {
    span {
      display: none;
    }
    div {
      flex-direction: column;

      .icon {
        margin: 0 auto;
        font-size: 26px;
        margin-top: 1rem;
      }
    }
  }

  @media (max-width: 600px) {
    .icon {
        font-size: 20px !important;
      }
  }
`

export default Layout
